var amt_admin = require("amt_admin").default;
var angular = require("angular");
var app = angular.module("ww2_analytics.admin_events", [amt_admin]);

app.service("admin_events_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("admin_events");
    this.events = service.createMethod("events");
    this.events_consistency = service.createMethod("events_consistency");
    this.recreate_distributed_queries = service.createMethod(
      "recreate_distributed_queries"
    );

    this.event_stats = service.createMethod("event_stats");
    this.event_schema = service.createMethod("event_schema");

    this.event_create_table = service.createMethod("event_create_table");
    this.event_drop_table = service.createMethod("event_drop_table");
    this.event_recreate_distributed = service.createMethod(
      "event_recreate_distributed"
    );

    this.event_partitions = service.createMethod("event_partitions");
    this.event_partition_drop = service.createMethod("event_partition_drop");
    this.last_hours_timestamps = service.createMethod("last_hours_timestamps");
  }
]);

var events_list_tpl = require("./events_list.html");
var event_stats_tpl = require("./event_stats.html");
var event_schema_tpl = require("./event_schema.html");
var event_partitions_tpl = require("./event_partitions.html");
var events_consistency_tpl = require("./events_consistency.html");

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider
      .state("amt.ww2.admin.events", {
        url: "/explore_events",
        template: events_list_tpl,
        data: {
          priority: 0,
          title: "Events",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          events: [
            "admin_events_api",
            function(admin_events_api) {
              return admin_events_api.events({});
            }
          ],
          last_hours_timestamps: [
            "admin_events_api",
            function(migration_api) {
              return migration_api.last_hours_timestamps({ count: 48 });
            }
          ]
        },
        controller: [
          "$scope",
          "events",
          "APP_CONFIG",
          "last_hours_timestamps",
          function($scope, events, APP_CONFIG, last_hours_timestamps) {
            var ref_str =
              "ww2-analytics/collector/" +
              APP_CONFIG.AMT_ANALYTICS_KAFKA_GROUP_ID +
              "/income_events";

            $scope.events = events.events;
            $scope.db_size = events.db_size;
            $scope.tables_size = events.tables_size;
            $scope.total_tables_size = events.total_tables_size;
            $scope.hours_timestamps = last_hours_timestamps;

            $scope.sense_evetns_loaded = false;
            $scope.sense_evetns_chart_data = [];

            $scope.prepare_events_for_chart = function(events) {
              var processed_events = _.object(
                $scope.hours_timestamps,
                _.map($scope.hours_timestamps, function(item) {
                  return { x: item * 1000, y: 0 };
                })
              );
              var unknown_events = _.object(
                $scope.hours_timestamps,
                _.map($scope.hours_timestamps, function(item) {
                  return { x: item * 1000, y: 0 };
                })
              );
              var prepared_events = _.object(
                $scope.hours_timestamps,
                _.map($scope.hours_timestamps, function(item) {
                  return { x: item * 1000, y: 0 };
                })
              );
              var consumed_events = _.object(
                $scope.hours_timestamps,
                _.map($scope.hours_timestamps, function(item) {
                  return { x: item * 1000, y: 0 };
                })
              );
              for (var i in events) {
                var e = events[i];
                if (e.hasOwnProperty("$id")) {
                  var at_timestamp = parseInt(e.$id);
                  processed_events[at_timestamp]["y"] = e.processed;
                  unknown_events[at_timestamp]["y"] = e.unknown;
                  consumed_events[at_timestamp]["y"] = e.consumed;
                  prepared_events[at_timestamp]["y"] = e.prepared;
                }
              }
              return [
                { key: "Unknown", values: _.values(unknown_events) },
                { key: "Processed", values: _.values(processed_events) },
                { key: "Prepared", values: _.values(prepared_events) },
                { key: "Consumed", values: _.values(consumed_events) }
              ];
            };
          }
        ]
      })
      .state("amt.ww2.admin.events_consistency", {
        url: "/events_consistency",
        template: events_consistency_tpl,
        data: {
          priority: 0,
          title: "Schema consistency",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          events_consistency: [
            "admin_events_api",
            function(admin_events_api) {
              return admin_events_api.events_consistency({});
            }
          ]
        },
        controller: [
          "$scope",
          "events_consistency",
          function($scope, events_consistency) {
            $scope.server_data = events_consistency;
          }
        ]
      })
      .state("amt.ww2.admin.recreate_distributed_queries", {
        url: "/recreate_distributed_queries",
        template: '<p ng-bind-html="queries_html"></p>',
        data: {
          priority: 0,
          title: "Recreate distributed",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          queries: [
            "admin_events_api",
            function(admin_events_api) {
              return admin_events_api.recreate_distributed_queries({});
            }
          ]
        },
        controller: [
          "$scope",
          "queries",
          function($scope, queries) {
            $scope.queries = queries;

            var html = "<pre>";
            queries.forEach(function(item, i, arr) {
              html += " - " + item + "\n";
            });
            html += "</pre>";

            $scope.queries_html = html;
          }
        ]
      })
      .state("amt.ww2.event_stats", {
        url: "/event_stats/:event_table",
        template: event_stats_tpl,
        data: {
          priority: 0,
          title: "Event Stats",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          event_stats: [
            "admin_events_api",
            "$stateParams",
            function(migration_api, $stateParams) {
              return migration_api.event_stats({
                event_table: $stateParams.event_table
              });
            }
          ],
          last_hours_timestamps: [
            "admin_events_api",
            function(migration_api) {
              return migration_api.last_hours_timestamps({ count: 48 });
            }
          ]
        },
        controller: [
          "$scope",
          "event_stats",
          "$stateParams",
          "APP_CONFIG",
          "last_hours_timestamps",
          function(
            $scope,
            event_stats,
            $stateParams,
            APP_CONFIG,
            last_hours_timestamps
          ) {
            $scope.event = event_stats;
            $scope.hours_timestamps = last_hours_timestamps;
            var ref_str =
              "ww2-analytics/collector/" +
              APP_CONFIG.AMT_ANALYTICS_KAFKA_GROUP_ID +
              "/tables/" +
              $stateParams.event_table;

            $scope.sense_evetns_loaded = false;
            $scope.sense_evetns_chart_data = [];

            $scope.prepare_events_for_chart = function(events) {
              var consumed_events = _.object(
                $scope.hours_timestamps,
                _.map($scope.hours_timestamps, function(item) {
                  return { x: item * 1000, y: 0 };
                })
              );
              for (var i in events) {
                var e = events[i];
                if (e.hasOwnProperty("$id")) {
                  var at_timestamp = parseInt(e.$id);
                  consumed_events[at_timestamp]["y"] = e.consumed;
                }
              }
              return [{ key: "Consumed", values: _.values(consumed_events) }];
            };
          }
        ]
      })
      .state("amt.ww2.event_schema", {
        url: "/events_schema/:event_table",
        template: event_schema_tpl,
        data: {
          priority: 0,
          title: "Event Schema",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          event_schema: [
            "admin_events_api",
            "$stateParams",
            function(migration_api, $stateParams) {
              return migration_api.event_schema({
                event_table: $stateParams.event_table
              });
            }
          ]
        },
        controller: [
          "$scope",
          "event_schema",
          "$stateParams",
          "admin_events_api",
          function($scope, event_schema, $stateParams, admin_events_api) {
            $scope.event = event_schema;

            $scope.actions_logs = [];

            $scope.create_table = function() {
              admin_events_api
                .event_create_table({
                  event_table: $stateParams.event_table
                })
                .then(function(resp) {
                  $scope.actions_logs.unshift(resp);
                });
            };
            $scope.drop_table = function() {
              if (
                !confirm(
                  "Drop table " + $stateParams.event_table + " on all host?"
                )
              ) {
                return;
              }

              admin_events_api
                .event_drop_table({
                  event_table: $stateParams.event_table
                })
                .then(function(resp) {
                  $scope.actions_logs.unshift(resp);
                });
            };

            $scope.recreate_distributed = function() {
              admin_events_api
                .event_recreate_distributed({
                  event_table: $stateParams.event_table
                })
                .then(function(resp) {
                  $scope.actions_logs.unshift(resp);
                });
            };
          }
        ]
      })
      .state("amt.ww2.event_partitions", {
        url: "/event_partitions/:event_table",
        template: event_partitions_tpl,
        data: {
          priority: 0,
          title: "Event Partitions",
          role: "admin",
          hidden_filters: true
        },
        resolve: {
          event_partitions: [
            "admin_events_api",
            "$stateParams",
            function(admin_events_api, $stateParams) {
              return admin_events_api.event_partitions({
                event_table: $stateParams.event_table
              });
            }
          ]
        },
        controller: [
          "$scope",
          "event_partitions",
          "$stateParams",
          "admin_events_api",
          function($scope, event_partitions, $stateParams, admin_events_api) {
            $scope.hosts = event_partitions.hosts;
            $scope.partitions = event_partitions.partitions;

            $scope.drop_partition = function(partition) {
              if (
                !confirm(
                  "Remove partition " +
                    partition +
                    " for table " +
                    $stateParams.event_table +
                    "?"
                )
              ) {
                return false;
              }
              admin_events_api
                .event_partition_drop({
                  event_table: $stateParams.event_table,
                  partition: partition
                })
                .then(function(resp) {
                  admin_events_api
                    .event_partitions({ event_table: $stateParams.event_table })
                    .then(function(resp) {
                      $scope.partitions = resp.partitions;
                    });
                });
              return false;
            };
          }
        ]
      });
  }
]);

export default app.name;
